import classNames from 'classnames'
import React from 'react'
import * as Reakit from 'reakit/Tab'

import { BUTTON_DEFAULT_ELEMENT, Button, ButtonComponentProps } from '../button'
import { Icon, IconNameType, isValidIconName } from '../icon'
import { useTabsContext } from './tabs'

// Must have the same keys as ButtonSize
export enum TabSpacing {
  xxsmall = 'space-x-0.5', // 2px spacing
  xsmall = 'space-x-1', // 4px spacing
  none = 'space-x-1.5', // 6px spacing
  small = 'space-x-1.5', // 6px spacing
  regular = 'space-x-1.5', // 6px spacing
  medium = 'space-x-2', // 8px spacing
  large = 'space-x-2', // 8px spacing
}

function getRightContent(content: JSX.Element | IconNameType | undefined, isActive: boolean) {
  if (isValidIconName(content)) return <Icon name={content} />
  else if (React.isValidElement(content))
    return React.cloneElement(content as React.ReactElement<{ active: boolean }>, {
      active: isActive,
    })
  else return content
}

export function Tab<TagType extends React.ElementType = typeof BUTTON_DEFAULT_ELEMENT>({
  rounding = 'none',
  theme = 'tab',
  size = 'medium',
  children,
  ...props
}: React.PropsWithChildren<ButtonComponentProps<TagType>>) {
  const state = useTabsContext()
  const spacing = TabSpacing[size]

  return (
    <Reakit.Tab {...state} {...props}>
      {(itemProps: ButtonComponentProps<TagType>) => {
        const active = Boolean(itemProps['aria-selected'])
        const rightContent = getRightContent(itemProps.rightContent, active)

        return (
          <Button
            {...itemProps}
            active={active}
            theme={theme}
            size={size}
            rounding={rounding}
            rightContent={undefined}
            className={classNames('group/badge', props.className)}
            contentClass={classNames(spacing, 'flex', props.contentClass)}
          >
            <span>{children}</span>
            {rightContent}
          </Button>
        )
      }}
    </Reakit.Tab>
  )
}
